<div style="display: inline-grid;">
  <div class="row">
    <div class="col-10">
      <canvas #canvas [attr.id]="sourceImageId + 'Canvas'" [width]="Width" [height]="Height"
        (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()"></canvas>
    </div>
    <div class="col-2" style="align-self: end;margin-right: -17px;padding-bottom: 5px;">
      <div [attr.id]="sourceImageId +'savedImageContainer'" style="height: 65px;width: 65px;">
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-6">
      <button class="btn btn-danger" style="direction: ltr;" (click)="undoLastChange()"><i class="fa fa-undo"
          style="color: white;"></i>
        Undo</button>
    </div>
    <div class="col-6">
      <button class="btn btn-danger" style="direction: ltr;" (click)="clearCanvas()"><i class="fa fa-refresh"
          style="color: rgb(207, 121, 121);"></i> Clear
        Canvas</button>
    </div>
  </div>
</div>